import { gql } from '@apollo/client';

export const SHARE_LISTINGS_LINK_QUERY = gql`
    query shareListingsLink(
        $filters: FiltersInputObject
        $center: CoordinatesInputObject
        $bounds: BoundsInputObject
        $hasPhotos: Boolean
        $withParks: Boolean
        $location: String
        $utmCampaign: String
        $utmContent: String
        $utmSource: String
        $utmMedium: String
    ) {
        shareListingsLink(
            filters: $filters
            center: $center
            bounds: $bounds
            hasPhotos: $hasPhotos
            withParks: $withParks
            location: $location
            utmCampaign: $utmCampaign
            utmContent: $utmContent
            utmSource: $utmSource
            utmMedium: $utmMedium
        )
    }
`;
